import globals from "./globals";
import $ from "cash-dom";
import Plyr from "plyr";

const layout = (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        if ($("audio").length) {
            if (globals.debug) console.log("layout-audio initialized");
            var instances = [];
            $("audio").each(function () {
                instances.push(
                    new Plyr($(this)[0], {
                        controls: [
                            // "play-large",
                            "play",
                            "progress",
                            "duration",
                            "current-time",
                            "mute",
                            // "volume",
                            // "captions",
                            // "settings",
                            // "pip",
                            // "airplay",
                            // "fullscreen",
                        ],
                        debug: false,
                        invertTime: false,
                    })
                );
            });
        }
    });
})();

export default layout;
